<script>

    export let name = ''
    export let value = ''
</script>

<small>{ name }</small>
<div style="font-weight: bold;">{ value }</div>